<template>
  <section id="Staff" class="g_section">
    <div class="g_bg_text">
      <KinesisScroll
        tag="img"
        :src="'./static/hd_staff.svg'"
        :strength="100"
        type="translate"
        axis="y"
      />
    </div>
    <div class="g_hd_en_wrap">
      <FxText>
        <p class="g_hd_en">STAFF LIST</p>
      </FxText>
    </div>
    <div class="g_hd_ja_wrap">
      <FxText>
        <h2 class="g_hd_ja">スタッフ情報</h2>
      </FxText>
    </div>
    <div class="content_body">
      <p>
        <strong>4/29</strong> と
        <strong>5/10</strong>
        の二日間、店員として商品の説明をしてくれるスタッフをご紹介
      </p>
      <div class="staff_list">
        <div class="staff_item">
          <div class="staff_frame">
            <div class="staff_frame_in">
              <a href="https://twitter.com/john_amachi" target="_blank">
                <img src="../../assets/img_amachi.png" alt="あまちじょんこ" />
              </a>
            </div>
          </div>
          <a href="https://twitter.com/john_amachi" target="_blank" class="name"
            >あまちじょんこ</a
          >
        </div>
        <div class="staff_item">
          <div class="staff_frame">
            <div class="staff_frame_in">
              <a href="https://twitter.com/nailbeho" target="_blank">
                <img src="../../assets/img_nail.png" alt="ネイル" />
              </a>
            </div>
          </div>
          <a href="https://twitter.com/nailbeho" target="_blank" class="name"
            >ネイル</a
          >
        </div>
        <div class="staff_item">
          <div class="staff_frame">
            <div class="staff_frame_in">
              <a href="https://twitter.com/tanabota88" target="_blank">
                <img src="../../assets/img_monaca.png" alt="棚牡丹モナカ" />
              </a>
            </div>
          </div>
          <a href="https://twitter.com/tanabota88" target="_blank" class="name"
            >棚牡丹モナカ</a
          >
        </div>
        <div class="staff_item">
          <div class="staff_frame">
            <div class="staff_frame_in">
              <a href="https://twitter.com/sunamichan" target="_blank">
                <img src="../../assets/img_sunami.png" alt="すなみ監督" />
              </a>
            </div>
          </div>
          <a href="https://twitter.com/sunamichan" target="_blank" class="name"
            >すなみ監督</a
          >
        </div>
        <div class="staff_item">
          <div class="staff_frame">
            <div class="staff_frame_in">
              <a href="https://twitter.com/gingorira" target="_blank">
                <img src="../../assets/img_gingori.png" alt="銀ゴリ" />
              </a>
            </div>
          </div>
          <a href="https://twitter.com/gingorira" target="_blank" class="name"
            >銀ゴリ</a
          >
        </div>
        <div class="staff_item">
          <div class="staff_frame">
            <div class="staff_frame_in">
              <a href="https://twitter.com/dondontei_PR" target="_blank">
                <img src="../../assets/img_dondontei.png" alt="雉玉かえし" />
              </a>
            </div>
          </div>
          <a
            href="https://twitter.com/dondontei_PR"
            target="_blank"
            class="name"
            >雉玉かえし</a
          >
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import FxText from "../atoms/FxText";
import { KinesisScroll } from "vue-kinesis";
export default {
  name: "Staff",
  components: { KinesisScroll, FxText }
};
</script>

<style scoped>
.staff_list {
  display: flex;
  justify-content: space-between;
}
.staff_frame {
  position: relative;
  background: url("../../assets/img_staff_bg.svg") no-repeat 0 0;
}
.staff_frame:after {
  background: url("../../assets/img_staff_frame.svg") no-repeat 0 0;
  background-size: 100% auto;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  content: "";
  pointer-events: none;
}
.staff_item {
  text-align: center;
  font-weight: 900;
  font-feature-settings: "palt";
}
.staff_item a {
  color: #fff;
  text-decoration: none;
}
.staff_item a.name:after {
  content: "";
  display: inline-block;
  background: url("../../assets/icon_way_white.svg") no-repeat 50% 50%;
  width: 0.5rem;
  height: 1rem;
  margin: 0 0 0 0.2rem;
  vertical-align: middle;
}
@media screen and (max-width: 850px) {
  .staff_list {
    flex-wrap: wrap;
    width: 430px;
    margin: 20px auto;
  }
  .staff_item {
    margin-bottom: 20px;
  }
}
@media screen and (max-width: 500px) {
  .staff_list {
    width: 260px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/TheStaffSection.vue